const productSettings = {
  pageTitle: "Lappa-Einstellungen",
  backToSettings: "Einstellungen",
  pageHelmetTitle: "Rechnungsverlauf",
  pageTitles: {
    applications: "Anwendungen",
    billings: "Abrechnungen",
    plansAndUsage: "Pläne & Verbrauch",
    payments: "Zahlungen",
    sandbox: "Sandbox",
  },
  customerBillingNote:
    "Hier werden nur die Abrechnungsdaten Ihres Unternehmens angezeigt (keine Kundendokumente).",
  mainTabs: {
    applications: "Anwendungen",
    billingHistory: "Rechnungsverlauf",
    plansAndUsage: "Pläne & Verbrauch",
    payments: "Zahlungen",
    sandbox: "Sandbox",
  },
  sandbox: {
    cancel: "Abbrechen",
    navigation: {
      switchTo: "Zur Sandbox wechseln",
      currentSandbox: "Sandbox aktiv",
      switchBack: "Zum Live-Unternehmen zurückkehren",
      active: "Aktive Sandbox",
      open: "Zu dieser Sandbox wechseln",
      empty: "Es wurde noch keine Sandbox erstellt.",
      create: "Sandbox erstellen",
      manage: "Sandboxes verwalten",
      singleLimit: "Pro Unternehmen kann nur eine Sandbox erstellt werden.",
    },
    access: {
      title: "Diese Funktion ist in der Sandbox nicht verfügbar",
      disabledDescription:
        "Wechseln Sie zu Ihrem Live-Unternehmen, um diese Funktion zu verwenden.",
      noPermission:
        "Sie haben keine Berechtigung, diese Funktion in der Sandbox zu verwenden.",
      disabledHint: "In der Sandbox nicht verfügbar",
    },
    create: {
      configurationTitle: "Startkonfiguration",
      configurationDescription: "Wählen Sie, was die neue Sandbox enthalten soll.",
      copyAccount: "Konto kopieren",
      copyAccountDescription:
        "Einstellungen und Funktionen werden vom Live-Konto übernommen.",
      newSandbox: "Neue Sandbox erstellen",
      newSandboxDescription: "Vom Live-Konto wird nichts kopiert.",
      next: "Weiter",
      nameTitle: "Sandbox benennen",
      nameDescription:
        "Wir haben einen Namen erstellt. Sie können ihn jetzt oder später ändern.",
      nameLabel: "Sandbox-Name",
      nameRequired: "Geben Sie einen Sandbox-Namen ein.",
      nameTooLong: "Der Sandbox-Name darf höchstens 80 Zeichen lang sein.",
      regenerate: "Neu generieren",
      back: "Zurück",
      submit: "Sandbox erstellen",
    },
    manage: {
      title: "Sandboxes verwalten",
      description:
        "Erstellen Sie eine isolierte Testumgebung, ohne Live-Daten zu ändern.",
      emptyTitle: "Noch keine Sandbox",
      emptyDescription: "Erstellen Sie eine Sandbox, um Abläufe sicher zu testen.",
      sandboxDescription: "Von den Live-Unternehmensdaten isoliert",
      delete: "Sandbox löschen",
      deleteTitle: "Sandbox löschen",
      deleteDescription:
        "Diese Sandbox und alle Daten werden dauerhaft gelöscht. Dies kann nicht rückgängig gemacht werden.",
      deleteActiveHint:
        "Kehren Sie vor dem Löschen zum Live-Unternehmen zurück.",
      created: "Sandbox wurde erstellt.",
      deleted: "Sandbox wurde gelöscht.",
      retry: "Erneut versuchen",
    },
  },
  plansAndUsage: {
    innerTabs: {
      overview: "Übersicht",
      includedInPlan: "Im Plan enthalten",
      usageAndLimits: "Verbrauch",
    },
    emptyProduct: "Kein aktives Abonnement für dieses Produkt.",
    emptyProductHint: "Wählen Sie einen Plan, um dieses Produkt zu nutzen.",
    includedPlaceholder: "Im Plan enthalten — demnächst verfügbar.",
    usagePlaceholder: "Verbrauch — demnächst verfügbar.",
    overview: {
      subscriptionTitle: "Abonnement",
      creditsTitle: "Guthaben",
      addonsTitle: "Add-ons",
      activeBadge: "Aktiv",
      inactiveBadge: "Inaktiv",
      nextBillingDate: "Nächstes Abrechnungsdatum",
      billingCycle: "Abrechnungszyklus",
      billingCycleYearly: "Jährlich",
      billingCycleMonthly: "Monatlich",
      perYear: "/ Jahr",
      perMonth: "/ Monat",
      creditSingular: "Guthaben",
      creditPlural: "Guthaben",
      manageCredits: "Guthaben verwalten",
      changeSubscription: "Abonnement ändern",
      choosePlan: "Plan auswählen",
      buyAddons: "Add-ons kaufen",
      cancelSubscription: "Abonnement kündigen",
      planLabel: "Plan",
      statusLabel: "Status",
      priceLabel: "Preis",
      createdLabel: "Erstellt",
      includedCountries: "Enthaltene Länder",
      includedUsers: "Enthaltene Nutzer",
      vatReturns: "USt-Erklärungen",
      statesIncluded: "Enthaltene Bundesstaaten",
      registrationsIncluded: "Registrierungen",
      autoFiling: "Automatische Abgabe",
      includedFeaturesTitle: "Enthaltene Funktionen",
      subscriptionDetailsTitle: "Abonnementdetails",
      summaryTitle: "Abrechnungsübersicht",
      planCost: "Plankosten",
      addonsTotal: "Add-ons gesamt",
      total: "Gesamt",
    },
  },
  tabs: {
    proforma: "Proforma-Rechnung",
    taxInvoice: "Steuerrechnung",
    creditNote: "Gutschrift",
    payments: "Zahlungen",
    creditsSummary: "Guthabenübersicht",
  },
  proforma: {
    addonsLabel: "Add-ons:",
    viewPayment: "Anzeigen",
  },
  filters: {
    searchPlaceholder: "Suchen",
    proformaSearchPlaceholder: "Nach Rechnungsnummer oder Namen suchen",
    dateRangeLabel: "Datumsbereich",
    dateFrom: "Von",
    dateTo: "Bis",
    sortByStatus: "Nach Status filtern",
    sortByStatusPrefix: "Nach Status:",
    statusAll: "Alle",
    showAll: "Alle anzeigen",
    appsPrefix: "Apps:",
    proformaStatusNew: "Neu",
    proformaStatusProcessed: "Verarbeitet",
    proformaStatusVoided: "Ungültig",
    proformaStatusRefund: "Erstattung",
    proformaStatusBalanceRefund: "Guthaben-Erstattung",
    proformaAppLTax: "L'Tax",
    proformaAppLEpr: "L'EPR",
    proformaAppLInvoice: "L'Invoice",
    proformaAppLAuthorize: "L'Authorize",
    advancedFiltersTrigger: "Erweiterte Filter",
    advancedFiltersTitle: "Erweiterte Filter",
    advanced: {
      subscriptionType: "Abonnementtyp",
      subscriptionPlaceholder: "Abonnement auswählen",
      addons: "Add-ons",
      addonsPlaceholder: "Add-ons auswählen",
      amount: "Betrag",
      amountPlaceholder: "Betrag eingeben",
      optionNone: "\u2014",
      addonMockReports: "Reporting",
      addonMockCompliance: "Compliance",
    },
  },
  filterTabs: {
    moreOptions: "Weitere Optionen",
  },
  statuses: {
    PAID: "Bezahlt",
    PENDING: "Ausstehend",
    OPEN: "Offen",
    COMPLETED: "Abgeschlossen",
    CLOSED: "Geschlossen",
    FAILED: "Fehlgeschlagen",
    CANCELLED: "Storniert",
    paid: "Bezahlt",
    due: "Fällig",
    credited: "Gutgeschrieben",
  },
  statusFilter: {
    ALL: "Alle",
    PAID: "Bezahlt",
    PENDING: "Ausstehend",
    OPEN: "Offen",
    COMPLETED: "Abgeschlossen",
    CLOSED: "Geschlossen",
  },
  table: {
    created: "Erstellt",
    invoiceName: "Rechnungsname",
    creditNoteName: "Gutschriftname",
    relatedInvoice: "Zugehörige Rechnung",
    number: "Nummer",
    billingPeriod: "Abrechnungszeitraum",
    status: "Status",
    payment: "Zahlung",
    app: "App",
    amount: "Betrag",
    actions: "Aktionen",
  },
  billingTableEmpty: {
    title: "Keine Ergebnisse",
    proformaTitle: "Keine Einträge gefunden",
    proformaEmptyDescription: "Sie haben derzeit keine Proforma-Rechnungen.",
    emptyNoSearch: "Sie haben derzeit keine {{entity}}.",
    searchNoMatch: "Zu Ihrer Suche „{{query}}“ wurden keine Treffer gefunden.",
    clearSearch: "Suche leeren",
    entities: {
      _default: "Einträge für diesen Tab",
      PROFORMA: "Proforma-Rechnungen",
      TAX: "Steuerrechnungen",
      CREDIT_NOTE: "Gutschriften",
      PAYMENTS: "Zahlungen",
      CREDITS_SUMMARY: "Einträge in der Guthabenübersicht",
    },
  },
  loading: "Rechnungsverlauf wird geladen…",
  error: "Rechnungsverlauf konnte nicht geladen werden. Bitte erneut versuchen.",
  retry: "Erneut versuchen",
  billingRowActions: {
    viewDetails: "Details anzeigen",
    view: "Anzeigen",
    pay: "Bezahlen",
    edit: "Bearbeiten",
    void: "Ungültig machen",
    restore: "Wiederherstellen",
    download: "Herunterladen",
    delete: "Löschen",
  },
  rowActions: {
    download: "Herunterladen",
    view: "Details anzeigen",
    copyNumber: "Rechnungsnummer kopieren",
  },
  payments: {
    table: {
      type: "Typ",
      paymentMethod: "Zahlungsmethode",
    },
  },
  creditsSummary: {
    cards: {
      salesTaxAvailable: "Verfügbare Sales-Tax-Credits",
      salesListAvailable: "Verfügbare Sales-List-Credits",
    },
    filters: {
      sortByTypePrefix: "Sortieren nach Typ:",
      sortAll: "Alle",
      sortSalesTax: "Sales Tax",
      sortSalesList: "Sales List",
    },
    table: {
      description: "Beschreibung",
      id: "ID",
      creditType: "Credit-Typ",
      creditsLeft: "Verbleibende Credits",
      amount: "Betrag",
    },
  },
  taxInvoiceDetails: {
    status: "Status",
    invoiceDate: "Rechnungsdatum",
    invoiceNumber: "Rechnungsnummer",
    vatNumber: "USt-IdNr.",
    sectionTitle: "Rechnungsdetails",
    colItem: "Position",
    colQty: "Menge",
    colPrice: "Preis",
    total: "Gesamt",
    downloadPdf: "PDF herunterladen",
  },
  creditNoteDetails: {
    status: "Status",
    createdDate: "Erstellt",
    number: "Nummer",
    relatedInvoice: "Zugehörige Rechnung",
    sectionTitle: "Gutschriftdetails",
    colItem: "Position",
    colQty: "Menge",
    colPrice: "Preis",
    total: "Gesamt",
    downloadPdf: "PDF herunterladen",
  },
  proformaInvoiceDetails: {
    title: "Proforma-Rechnung",
    titleWithNumber: "Proforma-Rechnung {{number}}",
    app: "App",
    addonsHeading: "Add-ons",
    noInvoiceDetails: "Keine Rechnungsdetails",
  },
  proformaDeleteModal: {
    title: "Proforma-Rechnung löschen",
    description:
      "Diese Proforma-Rechnung wird dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
    descriptionWithNumber:
      "Die Proforma-Rechnung {{number}} wird dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
    cancel: "Abbrechen",
    delete: "Löschen",
  },
  proformaVoidModal: {
    title: "Proforma-Rechnung ungültig machen?",
    description:
      "Die Proforma-Rechnung wird als ungültig markiert. Sie können sie später bei Bedarf wiederherstellen.",
    descriptionWithNumber:
      "Die Proforma-Rechnung {{number}} wird als ungültig markiert. Sie können sie später bei Bedarf wiederherstellen.",
    cancel: "Abbrechen",
    void: "Rechnung ungültig machen",
    success: "Proforma-Rechnung erfolgreich als ungültig markiert.",
    errorGeneric: "Die Proforma-Rechnung konnte nicht storniert werden. Bitte erneut versuchen.",
  },
  proformaRestoreModal: {
    title: "Proforma-Rechnung wiederherstellen?",
    description:
      "Die Proforma-Rechnung wird wiederhergestellt und ihr Status auf Neu gesetzt.",
    cancel: "Abbrechen",
    restore: "Rechnung wiederherstellen",
    success: "Proforma-Rechnung erfolgreich wiederhergestellt.",
    errorGeneric: "Die Proforma-Rechnung konnte nicht wiederhergestellt werden. Bitte erneut versuchen.",
  },
  proformaPayModal: {
    title: "Proforma-Rechnung bezahlen",
    description:
      "Möchten Sie die Proforma-Rechnung {{number}} vom {{date}} über {{amount}} bezahlen?",
    numberFallback: "\u2014",
    cancel: "Abbrechen",
    pay: "Bezahlen",
    shopifyPay: "Jetzt mit Shopify Pay kaufen",
  },
  proformaInvoiceEdit: {
    drawerTitle: "Proforma-Rechnung bearbeiten",
    cancel: "Abbrechen",
    save: "Speichern",
    pdfLabel: "PDF-Rechnung",
    removeFile: "Entfernen",
    errorTitle: "Speichern fehlgeschlagen",
    errorGeneric: "Änderungen konnten nicht gespeichert werden.",
    errorNumberRequired: "Bitte Rechnungsnummer eingeben.",
    errorSumRequired: "Bitte Betrag eingeben.",
    errorSumInvalid: "Bitte einen gültigen Betrag eingeben.",
    errorUploadAfterSave: "Die Rechnung wurde gespeichert, aber der PDF-Upload ist fehlgeschlagen.",
    createdDateLabel: "Erstellungsdatum",
    createdDatePlaceholder: "Erstellungsdatum wählen",
    paymentDateLabel: "Zahlungsdatum",
    paymentDatePlaceholder: "Zahlungsdatum wählen",
  },
  mainTabSoon: "Demnächst",
};

export default productSettings;
